import produce from 'immer';
export var initialState = {
    helpModalData: {
        type: '',
        mainTitle: '',
        image: '',
        icon: '',
        leftTitle: '',
        leftContent: '',
        readMore: '',
        rightTitle: '',
        rightContent: [
            {
                link: '',
                label: '',
            },
        ],
    },
    welcomeModalData: {
        type: '',
        mainTitle: '',
        image: '',
        icon: '',
        leftTitle: '',
        leftContent: '',
        readMore: '',
        rightTitle: '',
        rightContent: [
            {
                link: '',
                label: '',
            },
        ],
    },
    error: null,
};
function introModalReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'INTRODUCTION_HELP_MODAL_DATA_REQUEST':
                state.helpModalData = {};
                state.error = false;
                break;
            case 'INTRODUCTION_HELP_MODAL_DATA_SUCCESS':
                state.helpModalData = action.modalData;
                state.error = false;
                break;
            case 'INTRODUCTION_HELP_MODAL_DATA_FAILURE':
                state.helpModalData = {};
                state.error = true;
                break;
            case 'INTRODUCTION_WELCOME_MODAL_DATA_REQUEST':
                state.welcomeModalData = {};
                state.error = false;
                break;
            case 'INTRODUCTION_WELCOME_MODAL_DATA_SUCCESS':
                state.welcomeModalData = action.modalData;
                state.error = false;
                break;
            case 'INTRODUCTION_WELCOME_MODAL_DATA_FAILURE':
                state.welcomeModalData = {};
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default introModalReducer;
